import React, { Component } from 'react';
import { connect } from 'react-redux'
import {
  Container,
  Grid,
  TextField,
  MenuItem,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";

import { GetLeadLists } from './LeadsAction';
import { GetBranches } from '../Branches/branchesAction';
import { GetClassifications } from '../Classifications/ClassificationsAcction';
import { GetThemes } from '../Themen/ThemesAction';
import LeadsSearchResults from './LeadsSearchResults';
import OverLoader from '../../components/common/loader';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import locale from "antd/es/date-picker/locale/de_DE";
import moment from "moment";
const dateFormat = 'YYYY';
const currentYear = moment().format(dateFormat);

class Leads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: new Date().getFullYear(),
      branch_id: '',
      classification_id: '',
      theme_id: '',
      group_id: '',
    }
  }

  componentDidMount() {
    this.getSavedGroupId()
    const { GetBranches, GetClassifications, GetThemes } = this.props;
    GetBranches();
    GetClassifications();
    GetThemes();
    setTimeout(() => {
      this.searchLeads()
    }, 1000)
  }

  yearHandler = (e) => {
    let date = moment(e).format(dateFormat);
    this.setState({ year: date }, () => {
      this.searchLeads()
    })
  }

  branchHandler = (e) => {
    this.setState({ branch_id: e.target.value }, () => {
      this.searchLeads()
    })
  }

  classificationHandler = (e) => {
    this.setState({ classification_id: e.target.value }, () => {
      this.searchLeads()
    })
  }

  themeHandler = (e) => {
    this.setState({ theme_id: e.target.value }, () => {
      this.searchLeads()
    })
  }

  groupHandler = (e) => {
    this.setState({ group_id: e.target.value }, () => {
      localStorage.setItem('group_id', e.target.value);
      this.searchLeads()
    })
  }

  getSavedGroupId = () => {
    const set_group_id = localStorage.getItem('group_id') || 3;
    this.setState({ group_id: set_group_id }, () => {
      localStorage.setItem('group_id', set_group_id)
    })
  }

  searchLeads() {
    const { GetLeadLists } = this.props;
    const { year, branch_id, classification_id, theme_id, group_id } = this.state;
    GetLeadLists(year, branch_id, classification_id, theme_id, group_id)
  }

  render() {

    const { branches_list, classifications_list, themes_list, isloading } = this.props;
    const { year, branch_id, classification_id, theme_id, group_id } = this.state;
    const access_rights = JSON.parse(localStorage.getItem('access_right'))

    return (
      <React.Fragment>
        {isloading && <OverLoader />}
        {Number(access_rights.leads) === 0 ?
          <Grid item md={12} sm={12} xs={12}>
            <div className="rightBlock rightBlock-bgWhite user-system">
              <h3>Access Denied</h3>
            </div>
          </Grid>
          :
          <Container maxWidth="xl">
            <Grid container spacing={1} className="mainBlock">
              <Grid item xs={12}>
                <div className="rightBlock liproCard leadDropDownBox">
                  <TableContainer component={Paper}>
                    <Table size="small" aria-label="dense table">
                      <TableBody>
                        <TableRow>
                          <TableCell align="right">
                            Jahr
                                                  </TableCell>
                          <TableCell align="right">
                            <DatePicker
                              locale={locale}
                              picker="year"
                              fullWidth
                              required
                              size="small"
                              value={year === '' ? this.setState({ year: currentYear }) : moment(year, dateFormat)}
                              format={dateFormat}
                              placeholder="YYYY"
                              allowClear={false}
                              bordered={false}
                              style={{ width: '100%' }}
                              onChange={(e) => this.yearHandler(e)}
                            />
                          </TableCell>
                          <TableCell align="right">
                            Branche
                                                  </TableCell>
                          <TableCell align="right">
                            <TextField
                              select
                              variant="outlined"
                              className="select-box"
                              size="small"
                              id="year"
                              value={branch_id}
                              onChange={(e) => this.branchHandler(e)}>
                              <MenuItem value='' selected={true}>Alle</MenuItem>
                              {
                                branches_list && branches_list.map(branch => (
                                  <MenuItem key={branch.id}
                                    value={branch.id}>{branch.name}</MenuItem>
                                ))
                              }
                            </TextField>
                          </TableCell>
                          <TableCell align="right">
                            Einstufung
                                                  </TableCell>
                          <TableCell align="right">
                            <TextField
                              select
                              variant="outlined"
                              className="select-box"
                              size="small"
                              id="year"
                              value={classification_id}
                              onChange={(e) => this.classificationHandler(e)}>
                              <MenuItem value='' selected={true}>Alle</MenuItem>
                              {
                                classifications_list && classifications_list.map(classification => (
                                  <MenuItem key={classification.id}
                                    value={classification.id}>{classification.name}</MenuItem>
                                ))
                              }
                            </TextField>
                          </TableCell>
                          <TableCell align="right">
                            Thema
                                                  </TableCell>
                          <TableCell align="right">
                            <TextField
                              select
                              variant="outlined"
                              className="select-box"
                              size="small"
                              id="year"
                              value={theme_id}
                              onChange={(e) => this.themeHandler(e)}>
                              <MenuItem value='' selected={true}>Alle</MenuItem>
                              {
                                themes_list && themes_list.map(theme => (
                                  <MenuItem key={theme.id}
                                    value={theme.id}>{theme.name}</MenuItem>
                                ))
                              }
                            </TextField>
                          </TableCell>
                          <TableCell align="right">
                            Gruppierung
                                                  </TableCell>
                          <TableCell align="right">
                            <TextField
                              select
                              variant="outlined"
                              className="select-box"
                              size="small"
                              value={group_id}
                              onChange={(e) => this.groupHandler(e)}>
                              <MenuItem value=''>Keine</MenuItem>
                              <MenuItem value={1}>Branche</MenuItem>
                              <MenuItem value={2}>Einstufung</MenuItem>
                              <MenuItem value={3}>Thema</MenuItem>
                              <MenuItem value={4}>Projektname</MenuItem>
                              <MenuItem value={5}>Kunde</MenuItem>
                              <MenuItem value={6}>Prozent</MenuItem>
                              <MenuItem value={7}>Lead Partner</MenuItem>
                            </TextField>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <LeadsSearchResults {...this.props} {...this.state} />
                </div>
              </Grid>
            </Grid>
          </Container>}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ branches, classifications, theme, leads }) => {
  return {
    isloading: leads.loading,
    branches_list: branches.branches_list,
    classifications_list: classifications.classifications_list,
    themes_list: theme.themes_list,
    leads_list: leads.leads_list
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetBranches: () => dispatch(GetBranches()),
    GetClassifications: () => dispatch(GetClassifications()),
    GetThemes: () => dispatch(GetThemes()),
    GetLeadLists: (year, branch_id, classification_id, theme_id, group_id) => dispatch(GetLeadLists(year, branch_id, classification_id, theme_id, group_id))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Leads);